export default __webpack_public_path__ + "67ce336f40993198a073612cec58866e.png";